<template>
	<!-- 支付弹框 -->
	<div class="modal-wrap">
        <div class="modal-content">
            <div class="modal-balance">
                <div class="body" :class='noWidth?"t-w":""'>{{firmTitle}}</div>
                <div class="footer">
                    <div class="cancelBtn"  @click="leftClick">{{firmLeft}}</div>
                    <div class="confirmBtn" :class='isEnough?"confirmCol":""' @click="rightClick">{{firmRight}}</div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    export default {
        name: 'ConfirmModal',
		props:{
            firmTitle:{
                type: String,
            },
            
            firmLeft:{
                type: String,
            },
            
            firmRight:{
                type: String,
            },
            
            isEnough:{
                type:Boolean,
            },
            
            noWidth:{
                type:Boolean,
            }
            
		},
        methods:{
            leftClick() {
                this.$emit('leftClick');
            },
            
            rightClick(){
                this.$emit('rightClick');
            }
        }
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
    .modal-wrap {position: fixed;top: 0;left: 0;right: 0;width: 100vw;height: 100vh;background:rgba(0,0,0,0.6);display: flex;justify-content: center;align-items: center; z-index: 12;}
    /* 余额不足弹框 */
    .modal-balance{.w(280);.f-s(18);background:rgba(255,255,255,1);border-radius:4px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);}
    .body {width: 130px;margin:0 auto;.p-t(38);.m-b(32);text-align: center;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1)}
    .t-w{width: auto}
    .footer {display: flex;justify-content: center;align-items: center;text-align: center;border-top: 1px solid #DDDDDD;}
    .cancelBtn, .confirmBtn {.w(140);.h(50);.l-h(50);font-size:18px;}
    .cancelBtn {border-right: 1px solid #DDDDDD;color:rgba(153,153,153,1)}
    .confirmBtn {font-family:PingFangSC-Medium;font-weight:500;color:rgba(65,132,244,1)}
    .confirmCol{background:rgba(65,132,244,1);color: #fff}
</style>
